import React from "react";
import "./style.css";

class Contact extends React.Component {
    constructor(props) {
        super(props);
        this.submitForm = this.submitForm.bind(this);
        this.state = {
            status: ""
        };
    }

    render() {
        const { status } = this.state;
        return (
            <form
                onSubmit={this.submitForm}
                action="https://formspree.io/f/roccolosito@gmail.com"
                method="POST"
            >
                <label>Reach Out !</label>
                <input placeholder="Email:" type="email" name="email"/>
                <textarea className="message" placeholder="Message:" type="text" name="message"/>
                {/* <input type="text" name="message" /> */}
                {status === "SUCCESS" ? <p>Thanks!</p> : <button>Send</button>}
                {status === "ERROR" && <p>Oops! There was an error.</p>}
            </form>
        );
    }

    submitForm(ev) {
        ev.preventDefault();
        const form = ev.target;
        const data = new FormData(form);
        const xhr = new XMLHttpRequest();
        xhr.open(form.method, form.action);
        xhr.setRequestHeader("Accept", "application/json");
        xhr.onreadystatechange = () => {
            if (xhr.readyState !== XMLHttpRequest.DONE) return;
            if (xhr.status === 200) {
                form.reset();
                this.setState({ status: "SUCCESS" });
            } else {
                this.setState({ status: "ERROR" });
            }
        };
        xhr.send(data);
    }
}

export default Contact;
